import React from "react";
const NotificationsContext = new React.createContext();
export default NotificationsContext;
